import { Transaction } from "@models/transaction"
import { Contact } from "@models/contact";
import { DirectDebitSummary } from "@models/direct-debit-summary";

export class TransactionsStore {

  constructor(
    public transactions: Transaction[] = [],
    public activeDebtor: Contact = null,
    public potentialTransactions: Transaction[] = [],
    public activeTransaction: Transaction = null,
    public directDebitSummaries: DirectDebitSummary[] = [],
    public activeDirectDebitSummary: DirectDebitSummary = null,
  ) {}

  static clone(store: TransactionsStore) {
    const result = new this()

    result.transactions = [...store.transactions]
    result.activeDebtor = store.activeDebtor
    result.potentialTransactions = [...store.potentialTransactions]
    result.activeTransaction = store.activeTransaction
    result.directDebitSummaries = [...store.directDebitSummaries]
    result.activeDirectDebitSummary = store.activeDirectDebitSummary

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/transactions.ts